import React from "react";
import { Progress, Row, Col, Card } from "antd";
import "./TasksProgress.less";
import { useSelector } from "react-redux";
import { toDisplayFormatWithTime } from "../../../lib/utils/formatDate";
import { ReactComponent as ErrorIcon } from "../../../img/red-square-icon.svg";
import { ReactComponent as SuccessIcon } from "../../../img/blue-square-icon.svg";

interface ITasksProgress {
  tasksCount: number;
  finishedSubtasks: number;
  successSubtasks: number;
  failedSubtasks: number;
  taskStatusId: number;
  initiator: string;
  createDate: number;
  changeDate: number;
  statusDescription: string;
}

function TasksProgress(props: ITasksProgress) {
  const {
    tasksCount,
    finishedSubtasks,
    successSubtasks,
    failedSubtasks,
    taskStatusId,
    initiator,
    createDate,
    changeDate,
    statusDescription,
  } = props;
  const { taskStatus: taskStatuses } = useSelector(
    // @ts-ignore
    (state) => state.rtkDictionaries
  );
  const percent = Math.round((successSubtasks + failedSubtasks) * (100 / tasksCount));
  const successPercent = Math.floor((successSubtasks * 100) / tasksCount);
  const barStatus = tasksCount === finishedSubtasks && failedSubtasks ? "exception" : "normal";
  const taskStatus = taskStatuses.find((tskStatus) => tskStatus.id === taskStatusId);

  return (
    <Card className="tasks-progress">
      <Progress
        className="progress-bar"
        percent={percent}
        status={barStatus}
        success={{ percent: successPercent, strokeColor: "rgba(0, 187, 119, 1)" }}
      />
      <Row justify="space-between" wrap={false}>
        <Col span={5}>
          <Row wrap={false}>
            <Col span={1}>
              <SuccessIcon />
            </Col>
            <Col span={12}>Обработано:</Col>
            <Col span={12}>
              {finishedSubtasks}/{tasksCount}
            </Col>
          </Row>
          <Row wrap={false}>
            <Col span={1}>
              <ErrorIcon />
            </Col>
            <Col span={12}>Ошибки:</Col> <Col span={12}>{failedSubtasks || 0}</Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row wrap={false}>
            <Col span={12}>Задание создано:</Col>
            <Col span={12}> {createDate && toDisplayFormatWithTime(createDate)}</Col>
          </Row>
          <Row className="row__margin-top" wrap={false}>
            <Col span={12}>Обработано:</Col>
            <Col span={12}>{changeDate && toDisplayFormatWithTime(changeDate)}</Col>{" "}
          </Row>
        </Col>
        <Col span={5}>
          <Row wrap={false}>
            <Col span={12}>Статус:</Col> <Col span={12}>{taskStatus?.name}</Col>
          </Row>
          <Row className="row__margin-top" wrap={false}>
            <Col span={12}>Инициатор:</Col> <Col span={12}>{initiator}</Col>
          </Row>
          <Row className="row__margin-top" wrap={false}>
            <Col span={12}>Комментарий:</Col> <Col span={12}>{statusDescription}</Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
}

export default TasksProgress;
